import { render, staticRenderFns } from "./TraxTrainingProgramCrudTable.vue?vue&type=template&id=1a35914a"
import script from "./TraxTrainingProgramCrudTable.vue?vue&type=script&lang=js"
export * from "./TraxTrainingProgramCrudTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports